import _ from 'lodash';
import debug from '../debug';

const getProductContent = (products, categorys) => {
    debug('getProductContent products', products);
    const ret = [];
    if (products.product && products.product.length) {
        _.each(categorys, (category) => {
            _.each(category.items, (item) => {
                const intersection = products.product.find((x) => item.scopes.find((y) => y.slug === x));
                if (intersection) {
                    if (!ret.find((x) => (x.slug === category.slug))) {
                        const includedCategory = {
                            slug: category.slug,
                            name: category.name,
                            items: [],
                        };
                        ret.push(includedCategory);
                    }
                    ret.map((i) => {
                        if (i.slug === category.slug) {
                            const updatedCategory = i;
                            updatedCategory.items.push(item);
                            return updatedCategory;
                        }
                        return i;
                    });
                }
            });
        });
    }
    debug('getProductContent categorys', categorys);
    debug('getProductContent ret', ret);
    return ret;
};

export default getProductContent;
